import styled from '@emotion/styled';

import { forMobile } from '@/design-system';
import { colorsPrimitives } from '@/shared/design-system/colors';

export const WHITE_BACKGROUND = colorsPrimitives.base.pureWhite;

export const CropArea = styled('div', {
  shouldForwardProp: (prop) => prop !== '$white',
})<{ $white: boolean }>(({ theme, $white }) => ({
  position: 'relative',
  width: '100%',
  height: 440,
  overflow: 'hidden',
  borderRadius: theme.radius[8],
  ...($white
    ? { backgroundColor: WHITE_BACKGROUND }
    : {
        backgroundImage: `repeating-conic-gradient(${theme.colors.background.overlay} 0% 25%, ${theme.colors.background.default} 0% 50%)`,
        backgroundSize: '16px 16px',
      }),

  [forMobile]: {
    height: 300,
  },
}));

export const Controls = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing[16],
  width: '100%',
  maxWidth: 420,
  margin: `${theme.spacing[24]}px auto 0`,
}));

export const ZoomSlider = styled('div')({
  width: '100%',
});
